module.exports = __webpack_public_path__ + "media/images/icons/dash-circle-bb67eff16a6eeb4fe324181444a3b8db.svg";